import React, { useState, useCallback, useImperativeHandle } from 'react';
import {
  Button,
  Row,
  Col,
  Image as ImageBS,
  Form,
  Popover,
  OverlayTrigger,
} from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { adminActions, alertActions } from '../../redux/_actions';
import {
  genderType,
  leagueType,
  imgType,
  FILE_SIZE,
} from '../../redux/_constants';
import * as Yup from 'yup';

export const SessionClips = React.forwardRef((props, ref) => {
  const { sessionId, isEditing, isSaving, reset, setIsLoading } = props;
  const { sessions } = useSelector((state) => state.admin);
  const session = sessions.byId[sessionId];

  const emptyList = () => {
    return (
      <Row
        style={{ minHeight: '40vh', textAlign: 'center' }}
        className="vCenter"
      >
        <span>No clips created.</span>
      </Row>
    );
  };

  const setupBody = () => {
    if (true) {
      // no such thing yet
      return emptyList();
    } else {
      return null;
    }
  };

  return (
    <Form onSubmit={null} className="sessionClips">
      {setupBody()}
    </Form>
  );
});
